import { useContext } from 'react';

import { CmsContentContext } from './cms-content-context';

export const useCmsContent = () => {
  return useContext(CmsContentContext)!;
};

export type CmsContent = ReturnType<typeof useCmsContent>;
